// src/config.ts
export const API_BASE =
  (
    // Vite
    (import.meta as any)?.env?.VITE_BACKEND_URL ??
    // CRA
    process.env.REACT_APP_BACKEND_URL ??
    // window-injected (optional)
    (window as any).__ENV__?.BACKEND_URL ??
    ""
  ).replace(/\/+$/, "");
